// extracted by mini-css-extract-plugin
export var box = "_6k-1";
export var checkboxRow = "_6k-8";
export var checked = "_6k-2";
export var descriptionSpacer = "_6k-a";
export var disabled = "_6k-3";
export var icon = "_6k-6";
export var input = "_6k-0";
export var labelSpacer = "_6k-9";
export var medium = "_6k-5";
export var small = "_6k-4";
export var text = "_6k-7";